import { MINUTES } from '@sequencehq/utils/dates'

export const PROGRESS_POLL_INTERVAL_MS = 1000
export const IMPORT_STALL_TIMEOUT_MS = 2 * MINUTES
export const MAX_PANEL_HEIGHT_PX = 400

export const TIMED_OUT_TITLE = 'Customer import timed out'
export const TIMED_OUT_MESSAGE =
  'This import is taking longer than expected. Customers that imported successfully will appear in your list.'
